import { RootState } from '@reducers';

export const selectFeaturePolicyCommissionInvoice = (state: RootState) => state.featureReducer.policyCommissionInvoiceReducer;
